import AbstractTrack from './abstract.track';
export class ErrorTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Error Occurred';
    }
    trackSegment(customTrackData, skipSegmentTrackData = false, context) {
        super.trackSegment(customTrackData, skipSegmentTrackData, context);
    }
}
